<app-modal-container
  class="modal-with-video"
  [buttons]="{close: true}"
  [hidden]="!videoReady"
  [spinnerProps]="{ isSpinnerActive: true }"
  (closeButtonClicked)="closeButtonClickedEmitter.emit()">
    <iframe
      class="w-[90vw] lg:w-[64rem] aspect-video h-auto"
      #videoPlayer
      [src]="vimeoUrl | safeUrl"
      allow="autoplay; fullscreen">
    </iframe>
</app-modal-container>

<div #spinnerDiv class="!static"></div>
